import React from 'react';
import { BouncingCoinIcon } from '../icons';

interface Props {
    title : string,
    subTitle : string,
}

const BounceLoader = ( { title, subTitle } : Props) => {
    return (
        <div className="page-loader">
            <div className="page-loader-inner">
                <div className="pl-coin-wrap">
                    <div className="pl-logo">
                        <BouncingCoinIcon/>
                    </div>
                </div>
                <div className="pl-shadow" />
                <div className="pl-text">
                    <span className="pl-title">{title}</span>
                    <span className="pl-sub">{subTitle}</span>
                </div>
            </div>
        </div>
    );
};

export default BounceLoader;